export const handleDownloadResponse = async (response: Response) => {
  if (response.status === 204 || !response.body) {
    return undefined;
  }
  if (response.status === 200) {
    return response.blob();
  }
  return response.json();
};
